import { memo } from 'react';
import { useTranslation } from '@aimsos/i18n';
import { SelectableChip } from '@aimsos/ui';

/**
 * The chip row of a Knowledge subtab (CT-5717 / CT-5718 / CT-5719): Drive,
 * Sandbox and Truth each pass their ids and the i18n prefix of their labels
 * (`<prefix>.<id>`, with `<prefix>.ariaLabel` naming the group). Toggle
 * buttons (`aria-pressed`); one is on.
 */
const KnowledgeQuickFilters = memo(function KnowledgeQuickFilters({ ids, labelPrefix, value, onChange }) {
  const { t } = useTranslation('unified-profiles');

  return (
    <div role="group" aria-label={t(`${labelPrefix}.ariaLabel`)} className="flex flex-wrap items-center gap-2">
      {ids.map((id) => (
        <SelectableChip key={id} size="m" selected={value === id} onClick={() => onChange(id)}>
          {t(`${labelPrefix}.${id}`)}
        </SelectableChip>
      ))}
    </div>
  );
});

export default KnowledgeQuickFilters;
